<template>
	<div>
		<el-card>
			<h1 class="title-biaoti">实时通话监控</h1>
			<el-row class="search">
				<label
					>主播ID：<el-input
						type="text"
						placeholder="请输入主播ID"
						v-model="search.hostRid"
				/></label>
				<label
					>主播等级：<el-select
						v-model="search.hostLevel"
						placeholder=""
					>
						<el-option label="Total" value=""></el-option>
						<el-option label="L0" value="L0"></el-option>
						<el-option label="L1" value="L1"></el-option>
						<el-option label="L2" value="L2"></el-option>
						<el-option label="L3" value="L3"></el-option>
						<el-option
							label="L4"
							value="L4"
						></el-option> </el-select
				></label>
				<label
					>用户ID：<el-input
						type="text"
						placeholder="请输入用户ID"
						v-model="search.userRid"
				/></label>
				<el-button type="primary" @click="query">查询</el-button>
				<el-button type="success" @click="showVideoMore"
					>一键查看</el-button
				>
				<el-button type="warning" @click="query">刷新</el-button>
			</el-row>
			<el-row>
				<el-table
					:data="dataList"
					style="width: 100%"
					stripe
					border
					v-loading="loading"
					@select="checkbox_select"
					@select-all="checkbox_select"
				>
					<el-table-column width="50" align="center" type="selection">
					</el-table-column>
					<el-table-column
						prop="recordId"
						label="通话编号"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="callType"
						label="通话类型"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="redial"
						label="7日内复播"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="hostRid"
						label="主播ID"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="hostName"
						label="主播昵称"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="hostLevel"
						label="主播等级"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="hostCountry"
						label="主播国家"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="hostLanguage"
						label="主播语言"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="userRid"
						label="用户ID"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="userCountry"
						label="用户国家"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="userLanguage"
						label="用户语言"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="realChatTime"
						label="通话时长(S)"
						align="center"
					>
					</el-table-column>
					<el-table-column prop="state" label="状态" align="center">
						<template slot-scope="scope">
							<div class="green">{{ scope.row.state }}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<div class="blue" @click="showVideo(scope.row)">
								查询
							</div>
						</template>
					</el-table-column>
				</el-table>
			</el-row>
			<el-row>
				<el-pagination
					@current-change="handleCurrent"
					:current-page="pageInfo.page"
					:page-size="pageInfo.size"
					layout="total,prev, pager, next, jumper"
					:total="pageInfo.total"
				>
				</el-pagination>
			</el-row>
		</el-card>
	</div>
</template>
<script>
export default {
	data() {
		return {
			search: {
				hostRid: '',
				hostLevel: '',
				userRid: '',
			},
			pageInfo: {
				page: 1,
				total: 0,
				size: 20,
			},
			dataList: [],
			selectRow: [],
			loading: false,
		}
	},
	created() {
		this.query()
	},
	methods: {
		async query() {
			this.loading = true
			const { data: res } = await this.$axios({
				method: 'get',
				url:
					this.$store.getters.path.videoCallSurveillance +
					'?username=' +
					this.$store.getters.username +
					'&token=' +
					this.$store.getters.token,
				withCredentials: true,
				params: {
					hostRid: this.search.hostRid,
					hostLevel: this.search.hostLevel,
					userRid: this.search.userRid,
					page: this.pageInfo.page,
				},
			})
			this.loading = false
			if (res.code != 0) return this.$message(res.msg)
			this.dataList = res.data.data
			this.pageInfo.total = res.data.total
		},
		showVideo(row) {
			this.$router.push({
				name: 'video',
				params: { cid: [row.cid] },
			})
		},
		showVideoMore() {
			if (this.selectRow.length === 0) {
				return this.$message('请选择需要监控的用户')
			}
			this.$router.push({
				name: 'video',
				params: { cid: this.selectRow },
			})
		},
		handleCurrent(newpage) {
			this.page = newpage
			this.query()
		},
		checkbox_select(row) {
			this.selectRow = []
			row.map((item) => {
				this.selectRow.push(item.cid)
			})
		},
	},
}
</script>
<style lang="scss" scoped>
.search {
	display: flex;
	> * {
		margin: 0 5px;
		display: flex;
		align-items: center;
		.el-input {
			width: 150px;
		}
	}
}
.green,
.blue {
	padding: 5px;
	background: rgb(65, 236, 65);
	color: #fff;
	border-radius: 5px;
}
.blue {
	background: #409eff;
}
</style>
